var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfidentialite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 601,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M603.5 0H0c427.5 294.5-123 316.5 361 600.5h242.5V0z",
    fill: "#078DBE",
    fillOpacity: 0.8
  })));
}

export default __webpack_public_path__ + "f7f17afc871a2d9c51e54c60ad8f0962.svg";
export { SvgConfidentialite as ReactComponent };